export default "__VITE_ASSET__CotIY81O__"